var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{staticClass:"mt-6 pt-6 mx-n2",attrs:{"caption":this.user.name,"disable-filtering":"","headers":_vm.headers,"items":_vm.items,"items-per-page":3,"mobile-breakpoint":350,"locale":"sv-SE","footer-props":{
    itemsPerPageOptions: [3, 9],
    itemsPerPageAllText: 'Alla',
    itemsPerPageText: 'Per sida:',
  }},scopedSlots:_vm._u([{key:"item.rating",fn:function(ref){
  var item = ref.item;
return [_c('div',{staticClass:"rating"},[_vm._v(_vm._s(item.rating))])]}},{key:"item.average",fn:function(ref){
  var item = ref.item;
return [_c('div',{staticClass:"average"},[_vm._v(_vm._s(item.average))])]}},{key:"footer.page-text",fn:function(ref){
  var pageStart = ref.pageStart;
  var pageStop = ref.pageStop;
  var itemsLength = ref.itemsLength;
return [_vm._v(" "+_vm._s(pageStart)+" - "+_vm._s(pageStop)+" av "+_vm._s(itemsLength)+" ")]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }